import { TextFontFamilies } from "./types";
export const theme = {
    palette: {
        primary: {
            main: "#2C2E6A",
            onMain: "#FFFFFF",
            container: "#F1F1FB",
            onContainer: "#131438",
        },
        secondary: {
            main: "#1BB0BC",
            onMain: "#FFFFFF",
            container: "#E9F8F9",
            onContainer: "#05375A",
        },
        accent: {
            main: "#858988",
            onMain: "#FFFFFF",
            container: "#F8FBFA",
            onContainer: "#373D3B",
        },
        surface: {
            main: "#060B0B",
            onMain: "#FFFFFF",
            container: "#F7FAF9",
            onContainer: "#060B0B",
        },
        success: {
            main: "#37B05B",
            onMain: "#FFFFFF",
            container: "#F4FCF7",
            onContainer: "#034733",
        },
        info: {
            main: "#3B82CA",
            onMain: "#FFFFFF",
            container: "#F6F9FE",
            onContainer: "#032061",
        },
        warning: {
            main: "#E6AD39",
            onMain: "#FFFFFF",
            container: "#FEF9F4",
            onContainer: "#9A5500",
        },
        error: {
            main: "#BB4049",
            onMain: "#FFFFFF",
            container: "#FEF6F6",
            onContainer: "#520528",
        },
        chartPositive: {
            main: "#14C283",
            onMain: "#FFFFFF",
            container: "#F0FEF4",
            onContainer: "#00572F",
        },
        chartNegative: {
            main: "#F04C4C",
            onMain: "#FFFFFF",
            container: "#FFEAEE",
            onContainer: "#B80817",
        },
        disabled: {
            main: "#D8D8D8",
            onMain: "#FFFFFF",
            container: "#F7F8FA",
            onContainer: "#A3A3A3",
        },
        background: {
            main: "#FFFFFF",
            onMain: "#060B0B",
            container: "#FBFBFB",
            onContainer: "#060B0B",
        },
        outline: "#E0E0E0",
        focused: "#C3C3C3",
        stroke: {
            50: "#F5F5F5",
            100: "#F2F2F2",
            200: "#E0E0E0",
            300: "#C1C1C1",
        },
        charts: {
            celestial: {
                main: "#3E92CC",
                onMain: "#BFDAEE",
                container: "#8EA8C3",
                onContainer: "#13293D",
            },
            cosmic: {
                main: "#4A3AFF",
                onMain: "#C6D2FD",
                container: "#E0C6FD",
                onContainer: "#962DFF",
            },
            venetian: {
                main: "#565676",
                onMain: "#D8DCFF",
                container: "#C38D94",
                onContainer: "#A76571",
            },
            viridian: {
                main: "#2A7F62",
                onMain: "#C1D6D7",
                container: "#588689",
                onContainer: "#143E30",
            },
        },
    },
    typography: {
        h: {
            fontFamily: TextFontFamilies.neuelKabel,
            fontSize: "4rem", // 64px
        },
        h1: {
            fontFamily: TextFontFamilies.neuelKabel,
            fontSize: "3.25rem", // 52px
        },
        h2: {
            fontFamily: TextFontFamilies.neuelKabel,
            fontSize: "2.625rem", // 42px
        },
        h3: {
            fontFamily: TextFontFamilies.neuelKabel,
            fontSize: "2rem", // 32px
        },
        h4: {
            fontFamily: TextFontFamilies.neuelKabel,
            fontSize: "1.75rem", // 28px
        },
        h5: {
            fontFamily: TextFontFamilies.neuelKabel,
            fontSize: "1.5rem", // 24px
        },
        h6: {
            fontFamily: TextFontFamilies.neuelKabel,
            fontSize: "1.25rem", // 20px
        },
        title1: {
            fontFamily: TextFontFamilies.neuelKabel,
            fontSize: "1.125rem", // 18px
        },
        title2: {
            fontFamily: TextFontFamilies.neuelKabel,
            fontSize: "1rem", // 16px
        },
        title3: {
            fontFamily: TextFontFamilies.neuelKabel,
            fontSize: "0.875rem", // 14px
        },
        title4: {
            fontFamily: TextFontFamilies.neuelKabel,
            fontSize: "0.75rem", // 12px
        },
        body: {
            fontFamily: TextFontFamilies.neuelKabel,
            fontSize: "1.5rem", // 24px
        },
        body1: {
            fontFamily: TextFontFamilies.neuelKabel,
            fontSize: "1.125rem", // 18px
        },
        body2: {
            fontFamily: TextFontFamilies.neuelKabel,
            fontSize: "1rem", // 16px
        },
        body3: {
            fontFamily: TextFontFamilies.neuelKabel,
            fontSize: "0.875rem", // 14px
        },
        body4: {
            fontFamily: TextFontFamilies.neuelKabel,
            fontSize: "0.75rem", // 12px
        },
        button: {
            fontFamily: TextFontFamilies.neuelKabel,
            fontSize: "0.875rem", // 14px
        },
        textFieldLabel: {
            fontFamily: TextFontFamilies.neuelKabel,
            fontSize: "0.875rem", // 14px
        },
        textFieldBody: {
            fontFamily: TextFontFamilies.neuelKabel,
            fontSize: "1rem", // 16px
        },
        textFieldHelperText: {
            fontFamily: TextFontFamilies.neuelKabel,
            fontSize: "0.75rem", // 12px
        },
        fontWeightRegular: 400,
        fontWeightSemiBold: 500,
        fontWeightBold: 700,
        maxMobileFontSize: "2rem", // 32px,
    },
    radius: {
        none: "0px",
        default: "4px",
        full: "100px",
        xs5: "4px",
        xs4: "6px",
        xs3: "8px",
        xs2: "10px",
        xs: "12px",
        sm5: "14px",
        sm4: "16px",
        sm3: "18px",
        sm2: "20px",
        sm: "22px",
        md5: "24px",
        md4: "26px",
        md3: "28px",
        md2: "30px",
        md: "32px",
        lg5: "34px",
        lg4: "36px",
        lg3: "38px",
        lg2: "40px",
        lg: "42px",
    },
    breakpoints: {
        xs: 0,
        sm: 600,
        md: 900,
        lg: 1200,
        xl: 1440,
    },
    shadows: {
        allAround: "-2px -2px 18px 0px rgba(6, 11, 11, 0.04)",
        left: "-4px 0px 5px 0px rgba(6, 11, 11, 0.03)",
        right: "4px 4px 5px 0px rgba(6, 11, 11, 0.03)",
        xs: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
        sm: "0px 1px 3px 0px rgba(16, 24, 40, 0.10), 0px 1px 2px 0px rgba(16, 24, 40, 0.06)",
        md: "0px 4px 8px -2px rgba(16, 24, 40, 0.10), 0px 2px 4px -2px rgba(16, 24, 40, 0.06)",
        lg: "0px 12px 16px -4px rgba(16, 24, 40, 0.08), 0px 4px 6px -2px rgba(16, 24, 40, 0.03)",
        xl: "0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)",
        xxl: "0px 24px 48px -12px rgba(16, 24, 40, 0.18)",
        xxxl: "0px 32px 64px -12px rgba(16, 24, 40, 0.14)",
    },
    zIndex: {
        mobileStepper: 1000,
        fab: 1050,
        speedDial: 1050,
        appBar: 1100,
        drawer: 1200,
        modal: 1300,
        popper: 1400,
        menu: 1500,
        snackbar: 1600,
        tooltip: 1700,
    },
    spacing: (value = 0, value2, value3, value4) => {
        const factor = 4;
        //All values are defined
        if (value2 && value3 && value4) {
            return `${value * factor}px ${value2 * factor}px ${value3 * factor}px ${value4 * factor}px`;
        }
        //Only two values are defined
        if (value2 && value3 && !value4) {
            return `${value * factor}px ${value2 * factor}px`;
        }
        //Only the second value is defined
        if (value2 && !value3 && !value4) {
            return `${value * factor}px ${value2 * factor}px`;
        }
        return `${value * factor}px`;
    },
    defaultProps: {},
};
//# sourceMappingURL=theme.js.map